import {
  screenSizeType,
  screenSizeTypeObject,
} from 'constants/screenSize';
import { useState, useEffect, useMemo } from 'react';

export type ScreenType = 'mobile' | 'tablet' | 'largeScreen';

interface ListGridType {
  gutter: number;
  column: number;
}

export interface ScreenStyleConfig {
  [key: string]: any;
}

export interface ScreenStyleProps<T extends ListGridType> {
  item: ScreenType;
  value: T;
}

const useMediaQuery = (): string | undefined => {
  const queries: string[] = screenSizeType;
  const [matches, setMatches] = useState<string | undefined>();

  useEffect(() => {
    const mediaQueryList = queries.map((query) =>
      window.matchMedia(query),
    );

    const initialMatch = mediaQueryList.find(
      (mq) => mq.matches,
    )?.media;
    setMatches(initialMatch);

    const listener = (event: MediaQueryListEvent) => {
      if (event.matches) {
        setMatches(event.media);
      }
    };

    mediaQueryList.forEach((mq) =>
      mq.addEventListener('change', listener),
    );

    return () => {
      mediaQueryList.forEach((mq) =>
        mq.removeEventListener('change', listener),
      );
    };
  }, [queries]);

  const filterScreenList = (screen: string | undefined) => {
    return screenSizeTypeObject[screen || ''];
  };

  const matchedScreen: string = filterScreenList(matches);

  return matchedScreen;
};

export const useScreenStyle = (
  screenType: ScreenType,
  styleConfig: Record<ScreenType, ScreenStyleConfig>,
): ScreenStyleConfig => {
  return useMemo(() => {
    return styleConfig[screenType] || styleConfig.largeScreen;
  }, [screenType, styleConfig]);
};

export default useMediaQuery;
